import React from "react";
import { Link } from "react-router-dom";
import YouTube from "react-youtube";

import "./styles.css";

function youtube_parser(url) {
  var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = url.match(regExp);
  return match && match[7].length === 11 ? match[7] : false;
}

const Render = (props, context) => {
  if (!props.training) return <section className="desafios consigna pbxl" />;

  return (
    <section className="desafios consigna backgroundImage fullHeightCalc pbxl verticalCenterFlex">
      <div className="container pRel textContainer">
       

      <p className="cifra man avenirBK white upperCase alignCenter mtl">
          {props.training.points} <span className="avenirL">pts</span>
        </p>

        <h2 className="avenirBK white bgNone alignCenter titleSize mtm borderBottomNone ">{props.training.name}</h2>

      

        
        <YouTube
          videoId={youtube_parser(props.training.video)}
          className="displayBlock bgGreyXL mha mbl"
          onEnd={props.onVideoEnd}
        />
        <p
          className={`statusCon borderBox white mha ${
            props.training.completed ? "ok" : ""
          }`}
        >
          Capacitación: {props.training.completed ? "100" : "0"}%
        </p>

        <div className="textRegular alignCenter mha mtl">
          {props.training.content}
        </div>

        <ul className="btnUl unstyled">
          {props.enableQuestions && (
              <li>
                <Link
                  to={`/capacitaciones/${props.training.id}/preguntas`}
                  className="btn mha btnGold"
                >
                  Comenzar
                </Link>
              </li>
          )}
          <li>
            <Link to="/capacitaciones" className="btn btnVolver mha">
              &lt; Volver
            </Link>
          </li>
        </ul>
      </div>
    </section>
  );
};

Render.contextTypes = {};

export default Render;



// WEBPACK FOOTER //
// ./src/pages/DesafiosConsigna/Render.js